import React from "react";
import StudyAbroadBanner from "../../AVHRBanner/StudyAbroadbannerNew.png";
import {
  FaUniversity,
  FaWpforms,
  FaFileAlt,
  FaPassport,
  FaPlaneDeparture,
  FaGraduationCap,
} from "react-icons/fa";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import SupportAboard from "../../Images/SupportStudyabord.jpg";
import { FaCheckCircle } from "react-icons/fa";

function StudyAbroad() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const studypoints = [
    "📚 Backed by years of academic and industry knowledge",
    "🌐 Personalized mentorship from global education experts",
    "🤝 Ethical guidance, with student-first values",
    "✨ Focused on clarity, confidence, and successful outcomes",
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={StudyAbroadBanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Edu Support</p>

              <h1 className="career-library-heading">Study Abroad</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">
              Your Pathway to International Education Begins Here
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              At AV-CS EduSupport, we offer end-to-end support for students
              aiming to pursue higher education abroad, through our expert-led
              partners, From choosing the right course to arriving at your dream
              university — we walk with you every step of the way
            </p>
          </div>
        </div>

        <div
          className="py-10 px-4 sm:px-6 lg:px-20 carrerbackgroundcolour pt-2"
          style={{ backgroundColor: "#FEFDED" }}
        >
          <h2 className="text-center mb-4 avhrProject-h2">
            Our Holistic Study Abroad Support Includes
          </h2>

          <div className="grid">
            <div className="col-12 grid">
              {/* Box 1 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaUniversity className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🧭</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Career & Course Mapping
                  </h3>
                  <p className="avhrProject-p">
                    We help students define their career goals and find the
                    best-fit courses at top universities worldwide, including in
                    the USA, UK, Canada, Australia, and Europe
                  </p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaWpforms className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">📌</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    University Shortlisting
                  </h3>
                  <p className="avhrProject-p">
                    Personalized list of institutions based on your academic
                    profile, preferences, and goals Guidance on academic and
                    extracurricular requirements
                  </p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaFileAlt className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">📝</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Application Assistance
                  </h3>
                  <p className="avhrProject-p">
                    Help with filling out application forms. Review and editing
                    of SOPs, LORs, and resumes. Support for application
                    timelines and documentation
                  </p>
                </div>
              </div>

              {/* Box 4 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaPassport className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">💰</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Financial Planning & Scholarship
                  </h3>
                  <p className="avhrProject-p">
                    Advice on budgeting, education loans, and scholarships.
                    Guidance on financial documentation
                  </p>
                </div>
              </div>

              {/* Box 5 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaPlaneDeparture className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🛃</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">Visa Support</h3>
                  <p className="avhrProject-p">
                    Document checklist and application guidance. Mock visa
                    interviews and confidence-building tips
                  </p>
                </div>
              </div>

              {/* Box 6 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaGraduationCap className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🧳</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3 ">
                    Pre-Departure Briefing
                  </h3>
                  <p className="avhrProject-p">
                    Cultural orientation and travel planning. Accommodation and
                    packing advice. Tips for adjusting to international student
                    life
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2 mt-4"
          style={{ backgroundColor: "#FDF6EC" }}
        >
          {/* Content */}
          <div className="col-12 md:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">
              🎓 Why Choose AV-CS EduSupport for Study Abroad
            </h2>
            <ul className="list-none pl-4">
              {studypoints.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="col-12 md:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={SupportAboard}
              alt=""
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(120deg, #D3669E, #FF8A7F, #FFCB5C)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">
              🌟 Global Dreams, Local Support
            </p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              We believe that every student deserves the opportunity to study
              abroad — with clarity, confidence, and care
            </h2>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default StudyAbroad;
